import { render, staticRenderFns } from "./listaProdutoCard.vue?vue&type=template&id=6759459b&"
import script from "./listaProdutoCard.vue?vue&type=script&lang=js&"
export * from "./listaProdutoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports